import { memo, useEffect, useState } from "react";
import { useNodeContext } from "../../../../context/NodeContext";
import { useFormContext } from "../../../../context/FormContext";
import { MdDeleteOutline } from "react-icons/md";
import { Handle, Position } from "@xyflow/react";
import CustomHandle from "../custome_handle/CustomHandle";
import { BsShop } from "react-icons/bs";

function CustomerNode({ id, data, isConnectable }) {
  const {
    nodes,
    setShowShapeUpdateForm,
    shapeId,
    setShapeId,
    handleNodeDelete,
  } = useNodeContext();
  const { setNewFormId } = useFormContext();
  const [isDelBtn, setDelBtn] = useState(false);

  // useEffect for shoeing del button not active
  useEffect(() => {
    if (id === shapeId) {
      setDelBtn(true);
    } else {
      setDelBtn(false);
    }
  }, [shapeId]);

  const handleClick = async (e) => {
    e.stopPropagation();
    setDelBtn(!isDelBtn);
    if (Array.isArray(nodes)) {
      const selectedNode = nodes.find((node) => node.id === id);
      if (selectedNode.data.form === "" || selectedNode.data.form === null) {
        setNewFormId(null);
      } else {
        setNewFormId(selectedNode.data.form.form_builder_id);
        console.log("formidData: ", selectedNode.data);
      }
    }
    setShowShapeUpdateForm(true);
    setShapeId(id);
  };
  return (
    <div className="" onClick={handleClick}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ top: "60%", left: "-1px", zIndex: "10" }}
        isConnectable={isConnectable}
        // connectionCount={1}
      />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "0px",
        }}
      >
        <BsShop style={{ fontSize: "30px" }} />
        <span
          style={{
            position: "absolute",
            fontSize: "8px",
            bottom: "-10px",
            width: "max-content",
          }}
        >
          {data.value}
        </span>
        {isDelBtn && (
          <button
            style={{ top: "-4px", right: "-12px" }}
            className="btn pm_shape_del_btn"
            onClick={handleNodeDelete}
          >
            <MdDeleteOutline />
          </button>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{ top: "60%", right: "-1px" }}
        isConnectable={isConnectable}
        // connectionCount={1}
      />
    </div>
  );
}

export default memo(CustomerNode);
